export default "__VITE_ASSET__DkoRn$xB__"